import React, {useEffect, useState} from "react";
import "./Chatbot.css";
import { sbaAxios } from "../utils/sbaAxios";
import {getFavouritePrompts } from '../../config/apiConfig';

function TryPrompts({handleTextClick, isSeeMore, isReOrdered}) {
  const [favoritePrompts, setFavoritePrompts] = useState([]);

  const fetchFavouritePrompts = async () => {
    try {
      const response = await sbaAxios({ url: getFavouritePrompts });
      const sortedPrompts = response.sort((a, b) => a.sortOrder - b.sortOrder);
      setFavoritePrompts(sortedPrompts);
    } catch (error) {
      console.error("Error fetching favorite prompts:", error);
      setFavoritePrompts([]);
    }
  };

  useEffect(() => {
    fetchFavouritePrompts();
  }, [isReOrdered]);

  return (
    <div>
      <p className="my-5 text-light-emphasis text-center fs-6">
        Try Something with this
      </p>
      <div className="container">
        <div className="row">
          {favoritePrompts.slice(0, isSeeMore ? 9 : 3).map((prompt, index) => (
            <div key={index} className="col-12 col-md-4 my-2">
              <div
                className="card p-3 h-100 d-flex flex-column"
                onClick={() => handleTextClick(prompt.Prompt)}
              >
                <p className="flex-grow-2">{prompt.Prompt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TryPrompts;
